import { ParsedUrlQuery } from 'querystring';

export const getTextFromQuery = (query: ParsedUrlQuery) => {
  return (
    query
      ?.toString()
      ?.split('-')
      ?.filter((item) => item !== '')
      ?.map((word) => `${word?.[0]?.toLocaleUpperCase()}${word.slice(1)}`)
      ?.join(' ') ?? ''
  );
};

export const getTextFromSlug = (slug: string) => {
  return (
    slug
      ?.toString()
      ?.split('-')
      ?.filter((item) => item !== '')
      ?.map((word) => `${word?.[0]?.toLocaleUpperCase()}${word.slice(1)}`)
      ?.join(' ') ?? ''
  );
};
